import { render } from "./genericCRUD.vue?vue&type=template&id=6438941f"
import script from "./genericCRUD.vue?vue&type=script&lang=js"
export * from "./genericCRUD.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__